import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";
import { isNil } from "lodash";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import moment from "moment";
import {
  Dialog,
  DialogContent,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Switch,
  FormControlLabel,
  Grid,
  Divider,
  Tab,
  Tabs,
  Paper,
  Box,
} from "@material-ui/core";

import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";
import QueueSelect from "../QueueSelect";
import AgentesDaConexao from "./AgentesDaConexao";
import TabPanel from "../TabPanel";
import useWhatsAppModalStyles from "./whatsAppModalStyles";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import CloseIcon from "@material-ui/icons/Close";
import {
  channelLabel,
  numeroBruto,
  modalSubtitle,
} from "../../pages/Connections/connectionRules";
import formatSerializedId from "../../utils/formatSerializedId";
import { Autorenew, FileCopy } from "@material-ui/icons";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import SchedulesForm from "../SchedulesForm";
import usePlans from "../../hooks/usePlans";
import { AuthContext } from "../../context/Auth/AuthContext";
import { Colorize } from "@material-ui/icons";
import ColorPicker from "../ColorPicker";
import InputAdornment from "@material-ui/core/InputAdornment";
import Checkbox from "@material-ui/core/Checkbox";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";
import StarIcon from "@material-ui/icons/StarBorder";
import VerifiedIcon from "@material-ui/icons/VerifiedUser";
import GroupsIcon from "@material-ui/icons/Group";
import HistoryIcon from "@material-ui/icons/History";
import CallIcon from "@material-ui/icons/Call";
import AddCommentIcon from "@material-ui/icons/AddComment";
import RepeatIcon from "@material-ui/icons/Repeat";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import UndoIcon from "@material-ui/icons/Undo";
import TimerOffIcon from "@material-ui/icons/TimerOff";
import RuleIcon from "@material-ui/icons/PlaylistAddCheck";
import StarOutlineIcon from "@material-ui/icons/StarBorder";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import WarningIcon from "@material-ui/icons/WarningRounded";
import useAerosModalStyles from "../../styles/aerosModalStyles";
import { AEROS } from "../../styles/aerosTokens";
import IconButton from "@material-ui/core/IconButton";
import getRandomHexColor from "../../utils/getRandomHexColor";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    gap: 4,
  },

  multFieldLine: {
    marginTop: 12,
    display: "flex",
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(1),
    },
  },

  btnWrapper: {
    position: "relative",
  },
  importMessage: {
    marginTop: 12,
    marginBottom: 12,
    paddingBottom: 20,
    paddingTop: 3,
    padding: 12,
    border: "solid grey 2px",
    borderRadius: 4,
    display: "flex",
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(1),
    },
  },

  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },

  textField: {
    marginRight: theme.spacing(1),
    flex: 1,
  },
  tokenRefresh: {
    minWidth: "auto",
    display: "flex", // Torna o botão flexível para alinhar o conteúdo
    alignItems: "center", // Alinha verticalmente ao centro
    justifyContent: "center", // Alinha horizontalmente ao centro
  },
  colorAdorment: {
    width: 20,
    height: 20,
  },
  formControl: {
    width: 220,
    // paddingTop: 14
  },
  colorField: {
    width: 150,
  },
}));

// Cartão de tempo da aba Chatbot (mockup: ícone + rótulo + dica + valor com
// unidade). Fica FORA do componente: definido dentro do render, o React o
// trataria como um tipo novo a cada digitação e o campo perderia o foco.
const BotTimeCard = ({ a, icon, label, hint, unit, children }) => (
  <div className={a.botCard}>
    <div className={a.botCardHead}>
      {icon}
      {label}
    </div>
    <div className={a.botCardHint}>{hint}</div>
    <div className={a.botCardField}>
      {children}
      {unit && <span className={a.botCardUnit}>{unit}</span>}
    </div>
  </div>
);

const SessionSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
});

const WhatsAppModal = ({ open, onClose, whatsAppId, channel }) => {
  const classes = useStyles();
  const a = useWhatsAppModalStyles();
  const m = useAerosModalStyles();
  const [autoToken, setAutoToken] = useState("");

  const inputFileRef = useRef(null);

  const [attachment, setAttachment] = useState(null);
  const [attachmentName, setAttachmentName] = useState("");

  const initialState = {
    name: "",
    greetingMessage: "",
    complationMessage: "",
    outOfHoursMessage: "",
    ratingMessage: "",
    isDefault: false,
    token: "",
    maxUseBotQueues: 3,
    provider: "beta",
    expiresTicket: 0,
    allowGroup: false,
    enableImportMessage: false,
    groupAsTicket: "disabled",
    timeUseBotQueues: "0",
    timeSendQueue: "0",
    sendIdQueue: 0,
    expiresTicketNPS: "0",
    expiresInactiveMessage: "",
    timeInactiveMessage: "",
    inactiveMessage: "",
    maxUseBotQueuesNPS: 3,
    whenExpiresTicket: 0,
    timeCreateNewTicket: 0,
    greetingMediaAttachment: "",
    importRecentMessages: "",
    importOldMessages: "",
    importOldMessagesGroups: "",
    integrationId: "",
    collectiveVacationEnd: "",
    collectiveVacationStart: "",
    collectiveVacationMessage: "",
    queueIdImportMessages: null,
    isOficial: false,
    phone_number_id: "",
    waba_id: "",
    send_token: "",
    business_id: "",
    phone_number: "",
    color: getRandomHexColor(),
    flowInactiveTime: 0,
    flowIdInactiveTime: 0,
    timeAwaitActiveFlowId: 0,
    maxUseInactiveTime: 1,
    timeToReturnQueue: 0,
    triggerIntegrationOnClose: true,
    wavoip: "",
  };
  const [whatsApp, setWhatsApp] = useState(initialState);
  const [selectedQueueIds, setSelectedQueueIds] = useState([]);
  const [queues, setQueues] = useState([]);
  const [tab, setTab] = useState("general");
  const [enableImportMessage, setEnableImportMessage] = useState(false);
  const [importOldMessagesGroups, setImportOldMessagesGroups] = useState(false);
  const [closedTicketsPostImported, setClosedTicketsPostImported] =
    useState(false);
  const [importOldMessages, setImportOldMessages] = useState(
    moment().add(-1, "days").format("YYYY-MM-DDTHH:mm")
  );
  const [importRecentMessages, setImportRecentMessages] = useState(
    moment().add(-1, "minutes").format("YYYY-MM-DDTHH:mm")
  );
  const [copied, setCopied] = useState(false);
  const [integrations, setIntegrations] = useState([]);
  const [schedulesEnabled, setSchedulesEnabled] = useState(false);
  const [NPSEnabled, setNPSEnabled] = useState(false);
  const [showOpenAi, setShowOpenAi] = useState(false);
  const [showIntegrations, setShowIntegrations] = useState(false);
  const { user } = useContext(AuthContext);
  const [isOficial, setIsOficial] = useState(false);
  const [useWhatsappOfficial, setUseWhatsappOfficial] = useState(false);
  const [colorPickerModalOpen, setColorPickerModalOpen] = useState(false);

  const [schedules, setSchedules] = useState([
    {
      weekday: i18n.t("queueModal.serviceHours.monday"),
      weekdayEn: "monday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: i18n.t("queueModal.serviceHours.tuesday"),
      weekdayEn: "tuesday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: i18n.t("queueModal.serviceHours.wednesday"),
      weekdayEn: "wednesday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: i18n.t("queueModal.serviceHours.thursday"),
      weekdayEn: "thursday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: i18n.t("queueModal.serviceHours.friday"),
      weekdayEn: "friday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: "Sábado",
      weekdayEn: "saturday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: "Domingo",
      weekdayEn: "sunday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
  ]);

  const { get: getSetting } = useCompanySettings();
  const { getPlanCompany } = usePlans();

  const [triggerIntegrationOnClose, setTriggerIntegrationOnClose] =
    useState(true);
  const [integrationType, setIntegrationType] = useState("n8n");
  const [integrationTypeId, setIntegrationTypeId] = useState(null);

  const [webhooks, setWebhooks] = useState([]);
  const [flowIdNotPhrase, setFlowIdNotPhrase] = useState();
  const [flowIdWelcome, setFlowIdWelcome] = useState();
  const [flowIdInactiveTime, setFlowIdInactiveTime] = useState();
  const [timeAwaitActiveFlowId, setTimeAwaitActiveFlowId] = useState();
  const [showWavoipCall, setShowWavoipCall] = useState(false);

  useEffect(() => {
    if (!whatsAppId && !whatsApp.token) {
      setAutoToken(generateRandomCode(30));
    } else if (whatsAppId && !whatsApp.token) {
      setAutoToken(generateRandomCode(30));
    } else {
      setAutoToken(whatsApp.token);
    }
  }, [whatsAppId, whatsApp.token]);

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const planConfigs = await getPlanCompany(undefined, companyId);

      setShowOpenAi(planConfigs.plan.useOpenAi);
      setShowIntegrations(planConfigs.plan.useIntegrations);
      setUseWhatsappOfficial(planConfigs.plan.useWhatsappOfficial);
      setShowWavoipCall(planConfigs.plan.wavoip);
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/flowbuilder");
        setWebhooks(data.flows);
      } catch (err) {
        toastError(err);
      }
    })();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const settingSchedules = await getSetting({
        column: "scheduleType",
      });
      setSchedulesEnabled(settingSchedules.scheduleType === "connection");
      const settingNPS = await getSetting({
        column: "userRating",
      });
      setNPSEnabled(settingNPS.userRating === "enabled");
    };
    fetchData();
  }, []);

  const handleEnableImportMessage = async (e) => {
    setEnableImportMessage(e.target.checked);
  };

  const handleEnableIsOficial = async (e) => {
    setIsOficial(e.target.checked);
  };

  useEffect(() => {
    const fetchSession = async () => {
      if (!whatsAppId) return;

      try {
        const { data } = await api.get(`whatsapp/${whatsAppId}?session=0`);

        if (data && data?.flowIdNotPhrase) {
          const { data: flowDefault } = await api.get(
            `flowbuilder/${data.flowIdNotPhrase}`
          );
          const selectedFlowIdNotPhrase = flowDefault?.flow.id;
          setFlowIdNotPhrase(selectedFlowIdNotPhrase);
        }

        if (data && data?.flowIdWelcome) {
          const { data: flowDefault } = await api.get(
            `flowbuilder/${data.flowIdWelcome}`
          );
          const selectedFlowIdWelcome = flowDefault?.flow.id;
          setFlowIdWelcome(selectedFlowIdWelcome);
        }

        if (data && data?.flowIdInactiveTime) {
          const { data: flowDefault } = await api.get(
            `flowbuilder/${data.flowIdInactiveTime}`
          );
          const selectedFlowIdInactiveTime = flowDefault?.flow.id;
          setFlowIdInactiveTime(selectedFlowIdInactiveTime);
        }

        if (data && data?.timeAwaitActiveFlowId) {
          const { data: flowDefault } = await api.get(
            `flowbuilder/${data.timeAwaitActiveFlowId}`
          );
          const selectedTimeAwaitActiveFlowId = flowDefault?.flow.id;
          setTimeAwaitActiveFlowId(selectedTimeAwaitActiveFlowId);
        }

        setWhatsApp(data);
        setAttachmentName(data.greetingMediaAttachment);
        setAutoToken(data.token);
        const whatsQueueIds = data.queues?.map((queue) => queue.id);
        setSelectedQueueIds(whatsQueueIds);
        setIsOficial(channel === "whatsapp_oficial");
        setSchedules(data.schedules);
        if (!isNil(data?.importOldMessages)) {
          setEnableImportMessage(true);
          setImportOldMessages(data?.importOldMessages);
          setImportRecentMessages(data?.importRecentMessages);
          setClosedTicketsPostImported(data?.closedTicketsPostImported);
          setImportOldMessagesGroups(data?.importOldMessagesGroups);
        }
      } catch (err) {
        toastError(err);
      }
    };
    fetchSession();
  }, [whatsAppId]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/queue");
        setQueues(data);
      } catch (err) {
        toastError(err);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/queueIntegration");

        setIntegrations(data.queueIntegrations);
      } catch (err) {
        toastError(err);
      }
    })();
  }, []);

  const handleChangeQueue = (e) => {
    setSelectedQueueIds(e);
  };

  const handleChange = (e) => {
    setTriggerIntegrationOnClose(e.target.value);
  };

  const handleIntegrationTypeChange = (e) => {
    setIntegrationType(e.target.value);
    setIntegrationTypeId(e.target.value);
  };

  const handleSaveWhatsApp = async (values) => {
    if (!whatsAppId) setAutoToken(generateRandomCode(30));

    if (NPSEnabled) {
      if (isNil(values.ratingMessage)) {
        toastError(i18n.t("whatsappModal.errorRatingMessage"));
        return;
      }

      if (
        values.expiresTicketNPS === "0" &&
        values.expiresTicketNPS === "" &&
        values.expiresTicketNPS === 0
      ) {
        toastError(i18n.t("whatsappModal.errorExpiresNPS"));
        return;
      }
    }

    if (values.timeSendQueue === "") values.timeSendQueue = "0";

    if (
      (values.sendIdQueue === 0 ||
        values.sendIdQueue === "" ||
        isNil(values.sendIdQueue)) &&
      values.timeSendQueue !== 0 &&
      values.timeSendQueue !== "0"
    ) {
      toastError(i18n.t("whatsappModal.errorSendQueue"));
      return;
    }

    // promptId (agente "antes da distribuição") só é gravado pelo modal do
    // agente no Talk.ai; o backend ignora, e o front nem envia.
    // eslint-disable-next-line no-unused-vars
    const { promptId: _promptId, prompt: _prompt, ...dadosDoForm } = values;
    const whatsappData = {
      ...dadosDoForm,
      flowIdWelcome: flowIdWelcome ? flowIdWelcome : null,
      flowIdInactiveTime: flowIdInactiveTime ? flowIdInactiveTime : null,
      flowIdNotPhrase: flowIdNotPhrase ? flowIdNotPhrase : null,
      timeAwaitActiveFlowId: timeAwaitActiveFlowId
        ? timeAwaitActiveFlowId
        : null,
      queueIds: selectedQueueIds,
      importOldMessages: enableImportMessage ? importOldMessages : null,
      importRecentMessages: enableImportMessage ? importRecentMessages : null,
      importOldMessagesGroups: importOldMessagesGroups
        ? importOldMessagesGroups
        : null,
      closedTicketsPostImported: closedTicketsPostImported
        ? closedTicketsPostImported
        : null,
      token: autoToken ? autoToken : null,
      schedules,
      channel,
      triggerIntegrationOnClose: triggerIntegrationOnClose,
      integrationTypeId: triggerIntegrationOnClose ? integrationTypeId : null,
      color: values.color ? values.color : getRandomHexColor(),
      wavoip: values.wavoip ? values.wavoip : null,
    };
    delete whatsappData["queues"];
    delete whatsappData["session"];

    try {
      if (whatsAppId) {
        if (
          whatsAppId &&
          enableImportMessage &&
          whatsApp?.status === "CONNECTED"
        ) {
          try {
            setWhatsApp({ ...whatsApp, status: "qrcode" });
            await api.delete(`/whatsappsession/${whatsApp.id}`);
          } catch (err) {
            toastError(err);
          }
        }

        await api.put(`/whatsapp/${whatsAppId}`, whatsappData);
        if (attachment != null) {
          const formData = new FormData();
          formData.append("file", attachment);
          await api.post(`/whatsapp/${whatsAppId}/media-upload`, formData);
        }
        if (!attachmentName && whatsApp.greetingMediaAttachment !== null) {
          await api.delete(`/whatsapp/${whatsAppId}/media-upload`);
        }
      } else {
        const { data } = await api.post("/whatsapp", whatsappData);
        if (attachment != null) {
          const formData = new FormData();
          formData.append("file", attachment);
          await api.post(`/whatsapp/${data.id}/media-upload`, formData);
        }
      }
      toast.success(i18n.t("whatsappModal.success"));

      handleClose();
    } catch (err) {
      toastError(err);
    }
  };

  function generateRandomCode(length) {
    const charset =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyvz0123456789";
    let code = "";

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      code += charset.charAt(randomIndex);
    }
    return code;
  }

  const handleRefreshToken = () => {
    setAutoToken(generateRandomCode(30));
  };

  const handleChangeFlowIdNotPhrase = (e) => {
    console.log(e.target.value);
    setFlowIdNotPhrase(e.target.value);
  };

  const handleChangeFlowIdWelcome = (e) => {
    setFlowIdWelcome(e.target.value);
  };

  const handleChangeFlowIdInactiveTime = (e) => {
    setFlowIdInactiveTime(e.target.value);
  };

  const handleChangeTimeAwaitActiveFlowId = (e) => {
    setTimeAwaitActiveFlowId(e.target.value);
  };

  const handleCopyToken = () => {
    navigator.clipboard.writeText(autoToken); // Copia o token para a área de transferência
    setCopied(true); // Define o estado de cópia como verdadeiro
  };

  const handleSaveSchedules = async (values) => {
    toast.success("Clique em salvar para registar as alterações");
    setSchedules(values);
  };

  const handleClose = () => {
    onClose();
    setWhatsApp(initialState);
    setEnableImportMessage(false);
    // inputFileRef.current.value = null
    setAttachment(null);
    setAttachmentName("");
    setCopied(false);
  };

  const cabecalhoSubtitulo = useMemo(() => {
    const numero = numeroBruto(whatsApp);
    return modalSubtitle(whatsApp, numero ? formatSerializedId(numero) : "");
  }, [whatsApp]);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const handleFileUpload = () => {
    const file = inputFileRef.current.files[0];
    setAttachment(file);
    setAttachmentName(file.name);
    inputFileRef.current.value = null;
  };

  const handleDeleFile = () => {
    setAttachment(null);
    setAttachmentName(null);
  };

  return (
    <div className={classes.root}>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={false}
        classes={{ paper: a.paper }}
        scroll="paper"
      >
        <div className={a.header}>
          <div className={a.headerIcon}>
            <SyncAltIcon />
          </div>
          <div style={{ minWidth: 0 }}>
            <div className={a.title}>
              {whatsAppId
                ? `${i18n.t("whatsappModal.title.edit")}${
                    whatsApp.name ? ` · ${whatsApp.name}` : ""
                  }`
                : i18n.t("whatsappModal.title.add")}
            </div>
            <div className={a.subtitle}>{cabecalhoSubtitulo}</div>
          </div>
          <IconButton
            className={a.closeButton}
            onClick={handleClose}
            aria-label={i18n.t("aeros.header.close")}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <Formik
          initialValues={whatsApp}
          enableReinitialize={true}
          validationSchema={SessionSchema}
          onSubmit={(values, actions) => {
            setTimeout(() => {
              handleSaveWhatsApp(values);
              actions.setSubmitting(false);
            }, 400);
          }}
        >
          {({ values, touched, errors, isSubmitting }) => (
            <Form className={a.form}>
              <Paper className={a.tabsPaper} elevation={0} square>
                <Tabs
                  value={tab}
                  indicatorColor="primary"
                  textColor="primary"
                  scrollButtons="on"
                  variant="scrollable"
                  onChange={handleTabChange}
                  className={a.tabs}
                  classes={{ scrollButtons: a.tabScrollButton }}
                >
                  <Tab
                    className={a.tab}
                    label={i18n.t("whatsappModal.tabs.general")}
                    value={"general"}
                  />
                  <Tab
                    className={a.tab}
                    label={i18n.t("whatsappModal.tabs.integrations")}
                    value={"integrations"}
                  />
                  <Tab
                    className={a.tab}
                    label={i18n.t("whatsappModal.tabs.messages")}
                    value={"messages"}
                  />
                  <Tab
                    className={a.tab}
                    label={i18n.t("aeros.connections.tabs.chatbot")}
                    value={"chatbot"}
                  />
                  <Tab
                    className={a.tab}
                    label={i18n.t("whatsappModal.tabs.assessments")}
                    value={"nps"}
                  />
                  {user.showFlow === "enabled" && (
                    <Tab
                      className={a.tab}
                      label={i18n.t("aeros.connections.tabs.flow")}
                      value={"flowbuilder"}
                    />
                  )}
                  {schedulesEnabled && (
                    <Tab
                      className={a.tab}
                      label={i18n.t("whatsappModal.tabs.schedules")}
                      value={"schedules"}
                    />
                  )}
                </Tabs>
              </Paper>
              <div className={a.body}>
                <TabPanel
                  className={a.panel}
                  value={tab}
                  name={"general"}
                >
                  <DialogContent>
                    {/* Linha 1 do mockup: [Imagem] [Nome *] [Cor] */}
                    <div className={a.topRow}>
                      <div>
                        <input
                          type="file"
                          accept="video/*,image/*"
                          ref={inputFileRef}
                          style={{ display: "none" }}
                          onChange={handleFileUpload}
                        />
                        <Button
                          className={a.imageButton}
                          startIcon={<AddPhotoAlternateIcon />}
                          onClick={() => inputFileRef.current.click()}
                        >
                          {attachmentName || i18n.t("userModal.buttons.addImage")}
                        </Button>
                        {attachmentName && (
                          <IconButton
                            className={a.iconAction}
                            style={{ marginLeft: 6 }}
                            onClick={handleDeleFile}
                            aria-label={i18n.t("whatsappModal.buttons.cancel")}
                          >
                            <DeleteOutlineIcon />
                          </IconButton>
                        )}
                      </div>

                      <div>
                        <label className={m.fieldLabel} htmlFor="name">
                          {i18n.t("whatsappModal.form.name")} *
                        </label>
                        <Field
                          as={TextField}
                          id="name"
                          autoFocus
                          name="name"
                          error={touched.name && Boolean(errors.name)}
                          helperText={touched.name && errors.name}
                          variant="outlined"
                          className={m.input}
                        />
                      </div>

                      <div>
                        <label className={m.fieldLabel} htmlFor="color">
                          {i18n.t("connections.table.color")}
                        </label>
                        <Field
                          as={TextField}
                          name="color"
                          id="color"
                          onFocus={() => {
                            setColorPickerModalOpen(false);
                          }}
                          error={touched.color && Boolean(errors.color)}
                          helperText={touched.color && errors.color}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <div
                                  style={{ backgroundColor: values.color }}
                                  className={a.colorSwatch}
                                />
                              </InputAdornment>
                            ),
                            endAdornment: (
                              <IconButton
                                size="small"
                                onClick={() => setColorPickerModalOpen(true)}
                              >
                                <Colorize />
                              </IconButton>
                            ),
                          }}
                          variant="outlined"
                          className={m.input}
                        />
                        <ColorPicker
                          open={colorPickerModalOpen}
                          handleClose={() => setColorPickerModalOpen(false)}
                          onChange={(color) => {
                            values.color = color;
                            setWhatsApp(() => {
                              return { ...values, color };
                            });
                          }}
                        />
                      </div>
                    </div>

                    {/* Toggles do mockup: título + dica dentro da caixa */}
                    <div className={a.switchGrid}>
                      <div className={`${m.optionBox} ${a.switchBox}`}>
                        <StarIcon />
                        <div style={{ minWidth: 0 }}>
                          <div className={m.optionTitle}>
                            {i18n.t("whatsappModal.form.default")}
                          </div>
                          <div className={m.optionDesc}>
                            {i18n.t("aeros.connections.form.defaultHint")}
                          </div>
                        </div>
                        <FormControlLabel
                          control={
                            <Field
                              as={Switch}
                              color="primary"
                              name="isDefault"
                              checked={values.isDefault}
                            />
                          }
                          label={i18n.t("whatsappModal.form.default")}
                        />
                      </div>

                      {useWhatsappOfficial && channel === "whatsapp_oficial" && (
                        <div className={`${m.optionBox} ${a.switchBox}`}>
                          <VerifiedIcon />
                          <div style={{ minWidth: 0 }}>
                            <div className={m.optionTitle}>
                              {i18n.t("whatsappModal.form.isOficial")}
                            </div>
                            <div className={m.optionDesc}>
                              {i18n.t("aeros.connections.form.officialHint")}
                            </div>
                          </div>
                          <FormControlLabel
                            label={i18n.t("whatsappModal.form.isOficial")}
                            control={
                              <Switch
                                checked={isOficial}
                                onChange={handleEnableIsOficial}
                                name="isOficial"
                                color="primary"
                              />
                            }
                          />
                        </div>
                      )}

                      <div className={`${m.optionBox} ${a.switchBox}`}>
                        <GroupsIcon />
                        <div style={{ minWidth: 0 }}>
                          <div className={m.optionTitle}>
                            {i18n.t("whatsappModal.form.group")}
                          </div>
                          <div className={m.optionDesc}>
                            {i18n.t("aeros.connections.form.groupHint")}
                          </div>
                        </div>
                        <FormControlLabel
                          control={
                            <Field
                              as={Switch}
                              color="primary"
                              name="allowGroup"
                              checked={values.allowGroup}
                            />
                          }
                          label={i18n.t("whatsappModal.form.group")}
                        />
                      </div>
                    </div>

                    {/* Tratar grupos como ticket · Token da conexão */}
                    <div className={m.grid2}>
                      <div>
                        <label className={m.fieldLabel}>
                          {i18n.t("whatsappModal.form.groupAsTicket")}
                        </label>
                        <FormControl variant="outlined" fullWidth className={m.input}>
                          <Field
                            as={Select}
                            id="groupAsTicket"
                            name="groupAsTicket"
                          >
                            <MenuItem value={"disabled"}>
                              {i18n.t("whatsappModal.menuItem.disabled")}
                            </MenuItem>
                            <MenuItem value={"enabled"}>
                              {i18n.t("whatsappModal.menuItem.enabled")}
                            </MenuItem>
                          </Field>
                        </FormControl>
                      </div>

                      <div>
                        <label className={m.fieldLabel}>
                          {i18n.t("whatsappModal.form.token")}
                        </label>
                        <div className={a.tokenRow}>
                          <Field
                            as={TextField}
                            type="token"
                            fullWidth
                            value={autoToken}
                            variant="outlined"
                            className={m.input}
                            disabled
                          />
                          <IconButton
                            className={a.iconAction}
                            onClick={handleRefreshToken}
                            disabled={isSubmitting}
                            aria-label={i18n.t("aeros.connections.form.tokenRenew")}
                          >
                            <Autorenew />
                          </IconButton>
                          <IconButton
                            className={a.iconAction}
                            onClick={handleCopyToken}
                            style={copied ? { color: AEROS.cyan } : undefined}
                            aria-label={i18n.t("aeros.connections.form.tokenCopy")}
                          >
                            <FileCopy />
                          </IconButton>
                        </div>
                      </div>
                    </div>

                    {/* Credenciais da API oficial (Meta) */}
                    {isOficial && (
                      <div className={m.section} style={{ padding: 14 }}>
                        <div className={m.grid2}>
                          <div>
                            <label className={m.fieldLabel}>
                              {i18n.t("whatsappModal.form.phone_number_id")} *
                            </label>
                            <Field
                              fullWidth
                              as={TextField}
                              name="phone_number_id"
                              error={
                                touched.phone_number_id &&
                                Boolean(errors.phone_number_id)
                              }
                              helperText={
                                touched.phone_number_id && errors.phone_number_id
                              }
                              variant="outlined"
                              className={m.input}
                              required={isOficial}
                            />
                          </div>
                          <div>
                            <label className={m.fieldLabel}>
                              {i18n.t("whatsappModal.form.waba_id")} *
                            </label>
                            <Field
                              fullWidth
                              as={TextField}
                              name="waba_id"
                              error={touched.waba_id && Boolean(errors.waba_id)}
                              helperText={touched.waba_id && errors.waba_id}
                              variant="outlined"
                              className={m.input}
                              required={isOficial}
                            />
                          </div>
                          <div>
                            <label className={m.fieldLabel}>
                              {i18n.t("whatsappModal.form.business_id")} *
                            </label>
                            <Field
                              fullWidth
                              as={TextField}
                              name="business_id"
                              error={
                                touched.business_id && Boolean(errors.business_id)
                              }
                              helperText={
                                touched.business_id && errors.business_id
                              }
                              variant="outlined"
                              className={m.input}
                              required={isOficial}
                            />
                          </div>
                          <div>
                            <label className={m.fieldLabel}>
                              {i18n.t("whatsappModal.form.phone_number")} *
                            </label>
                            <Field
                              fullWidth
                              as={TextField}
                              name="phone_number"
                              error={
                                touched.phone_number &&
                                Boolean(errors.phone_number)
                              }
                              helperText={
                                touched.phone_number && errors.phone_number
                              }
                              variant="outlined"
                              className={m.input}
                              required={isOficial}
                            />
                          </div>
                        </div>
                        <div style={{ marginTop: 10 }}>
                          <label className={m.fieldLabel}>
                            {i18n.t("whatsappModal.form.send_token")} *
                          </label>
                          <Field
                            fullWidth
                            as={TextField}
                            name="send_token"
                            error={
                              touched.send_token && Boolean(errors.send_token)
                            }
                            helperText={touched.send_token && errors.send_token}
                            variant="outlined"
                            className={m.input}
                            required={isOficial}
                          />
                        </div>
                      </div>
                    )}

                    {/* Importação de mensagens antigas (só Baileys) */}
                    {!isOficial && (
                      <div className={m.section} style={{ padding: 14 }}>
                        <div className={`${m.optionBox} ${a.switchBox}`}>
                          <HistoryIcon />
                          <div style={{ minWidth: 0 }}>
                            <div className={m.optionTitle}>
                              {i18n.t(
                                "whatsappModal.form.importOldMessagesEnable"
                              )}
                            </div>
                            <div className={m.optionDesc}>
                              {i18n.t("aeros.connections.form.importHint")}
                            </div>
                          </div>
                          <FormControlLabel
                            label={i18n.t(
                              "whatsappModal.form.importOldMessagesEnable"
                            )}
                            control={
                              <Switch
                                checked={enableImportMessage}
                                onChange={handleEnableImportMessage}
                                name="importOldMessagesEnable"
                                color="primary"
                              />
                            }
                          />
                        </div>

                        {enableImportMessage && (
                          <>
                            <div className={m.grid2} style={{ marginTop: 12 }}>
                              <div>
                                <label className={m.fieldLabel}>
                                  {i18n.t("whatsappModal.form.importOldMessages")}
                                </label>
                                <Field
                                  fullWidth
                                  as={TextField}
                                  type="datetime-local"
                                  name="importOldMessages"
                                  inputProps={{
                                    max: moment()
                                      .add(0, "minutes")
                                      .format("YYYY-MM-DDTHH:mm"),
                                    min: moment()
                                      .add(-2, "years")
                                      .format("YYYY-MM-DDTHH:mm"),
                                  }}
                                  error={
                                    touched.importOldMessages &&
                                    Boolean(errors.importOldMessages)
                                  }
                                  helperText={
                                    touched.importOldMessages &&
                                    errors.importOldMessages
                                  }
                                  variant="outlined"
                                  className={m.input}
                                  value={moment(importOldMessages).format(
                                    "YYYY-MM-DDTHH:mm"
                                  )}
                                  onChange={(e) => {
                                    setImportOldMessages(e.target.value);
                                  }}
                                />
                              </div>
                              <div>
                                <label className={m.fieldLabel}>
                                  {i18n.t(
                                    "whatsappModal.form.importRecentMessages"
                                  )}
                                </label>
                                <Field
                                  fullWidth
                                  as={TextField}
                                  type="datetime-local"
                                  name="importRecentMessages"
                                  inputProps={{
                                    max: moment()
                                      .add(0, "minutes")
                                      .format("YYYY-MM-DDTHH:mm"),
                                    min: moment(importOldMessages).format(
                                      "YYYY-MM-DDTHH:mm"
                                    ),
                                  }}
                                  error={
                                    touched.importRecentMessages &&
                                    Boolean(errors.importRecentMessages)
                                  }
                                  helperText={
                                    touched.importRecentMessages &&
                                    errors.importRecentMessages
                                  }
                                  variant="outlined"
                                  className={m.input}
                                  value={moment(importRecentMessages).format(
                                    "YYYY-MM-DDTHH:mm"
                                  )}
                                  onChange={(e) => {
                                    setImportRecentMessages(e.target.value);
                                  }}
                                />
                              </div>
                            </div>

                            <div style={{ marginTop: 10 }}>
                              <label className={m.fieldLabel}>
                                {i18n.t(
                                  "whatsappModal.form.queueIdImportMessages"
                                )}
                              </label>
                              <FormControl
                                variant="outlined"
                                fullWidth
                                className={m.input}
                              >
                                <Field
                                  as={Select}
                                  name="queueIdImportMessages"
                                  id="queueIdImportMessages"
                                  value={values.queueIdImportMessages || "0"}
                                  required={enableImportMessage}
                                >
                                  <MenuItem value={0}>&nbsp;</MenuItem>
                                  {queues.map((queue) => (
                                    <MenuItem key={queue.id} value={queue.id}>
                                      {queue.name}
                                    </MenuItem>
                                  ))}
                                </Field>
                              </FormControl>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 14,
                                marginTop: 10,
                              }}
                            >
                              <FormControlLabel
                                label={i18n.t(
                                  "whatsappModal.form.importOldMessagesGroups"
                                )}
                                control={
                                  <Checkbox
                                    checked={importOldMessagesGroups}
                                    onChange={(e) =>
                                      setImportOldMessagesGroups(
                                        e.target.checked
                                      )
                                    }
                                    name="importOldMessagesGroups"
                                    color="primary"
                                  />
                                }
                              />
                              <FormControlLabel
                                label={i18n.t(
                                  "whatsappModal.form.closedTicketsPostImported"
                                )}
                                control={
                                  <Checkbox
                                    checked={closedTicketsPostImported}
                                    onChange={(e) =>
                                      setClosedTicketsPostImported(
                                        e.target.checked
                                      )
                                    }
                                    name="closedTicketsPostImported"
                                    color="primary"
                                  />
                                }
                              />
                            </div>

                            <div className={a.warnBox} style={{ marginTop: 10 }}>
                              <WarningIcon />
                              <span>
                                {i18n.t("whatsappModal.form.importAlert")}
                              </span>
                            </div>
                          </>
                        )}
                      </div>
                    )}
                  </DialogContent>
                </TabPanel>
                <TabPanel
                  className={a.panel}
                  value={tab}
                  name={"integrations"}
                >
                  <DialogContent>
                    {/* Redirecionamento de fila (no mockup mora nesta aba) */}
                    <div>
                      <div className={a.sectionTitle}>
                        {i18n.t("whatsappModal.form.queueRedirection")}
                      </div>
                      <div className={a.sectionDesc}>
                        {i18n.t("whatsappModal.form.queueRedirectionDesc")}
                      </div>
                      <div className={m.grid2}>
                        <div>
                          <label className={m.fieldLabel}>
                            {i18n.t("whatsappModal.form.sendIdQueue")}
                          </label>
                          <FormControl variant="outlined" fullWidth className={m.input}>
                            <Field
                              as={Select}
                              name="sendIdQueue"
                              id="sendIdQueue"
                              value={values.sendIdQueue || "0"}
                              required={values.timeSendQueue > 0}
                            >
                              <MenuItem value={0}>&nbsp;</MenuItem>
                              {queues.map((queue) => (
                                <MenuItem key={queue.id} value={queue.id}>
                                  {queue.name}
                                </MenuItem>
                              ))}
                            </Field>
                          </FormControl>
                        </div>
                        <div>
                          <label className={m.fieldLabel}>
                            {i18n.t("whatsappModal.form.timeSendQueue")}
                          </label>
                          <Field
                            as={TextField}
                            fullWidth
                            name="timeSendQueue"
                            variant="outlined"
                            className={m.input}
                            error={
                              touched.timeSendQueue &&
                              Boolean(errors.timeSendQueue)
                            }
                            helperText={
                              touched.timeSendQueue && errors.timeSendQueue
                            }
                          />
                        </div>
                      </div>
                    </div>

                    {/* Filas da conexão */}
                    <div>
                      <QueueSelect
                        selectedQueueIds={selectedQueueIds}
                        onChange={(selectedIds) => handleChangeQueue(selectedIds)}
                      />
                    </div>

                    {/* Agentes de IA: só leitura; o vínculo é editado no Talk.ai */}
                    {showOpenAi && (
                      <AgentesDaConexao
                        whatsappId={whatsAppId}
                        queueIds={selectedQueueIds}
                      />
                    )}

                    <div className={m.grid2}>
                      {showIntegrations && (
                        <div>
                          <label className={m.fieldLabel}>
                            {i18n.t("queueModal.form.integrationId")}
                          </label>
                          <FormControl variant="outlined" fullWidth className={m.input}>
                            <Field as={Select} name="integrationId" id="integrationId">
                              <MenuItem value={null}>
                                {i18n.t("whatsappModal.menuItem.disabled")}
                              </MenuItem>
                              {integrations.map((integration) => (
                                <MenuItem key={integration.id} value={integration.id}>
                                  {integration.name}
                                </MenuItem>
                              ))}
                            </Field>
                          </FormControl>
                        </div>
                      )}


                      <div>
                        <label className={m.fieldLabel}>
                          {i18n.t("whatsappModal.form.triggerIntegrationOnClose")}
                        </label>
                        <FormControl variant="outlined" fullWidth className={m.input}>
                          <Field
                            onChange={handleChange}
                            value={triggerIntegrationOnClose}
                            as={Select}
                            name="triggerIntegrationOnClose"
                            id="triggerIntegrationOnClose"
                          >
                            <MenuItem value={false}>
                              {i18n.t("whatsappModal.menuItem.disabled")}
                            </MenuItem>
                            <MenuItem value={true}>
                              {i18n.t("whatsappModal.menuItem.enabled")}
                            </MenuItem>
                          </Field>
                        </FormControl>
                      </div>

                      {triggerIntegrationOnClose && (
                        <div>
                          <label className={m.fieldLabel}>
                            {i18n.t("aeros.connections.form.closeIntegration")}
                          </label>
                          <FormControl variant="outlined" fullWidth className={m.input}>
                            <Field
                              as={Select}
                              name="integrationType"
                              id="integrationType"
                              value={integrationTypeId}
                              onChange={handleIntegrationTypeChange}
                            >
                              <MenuItem value={null}>
                                {i18n.t("whatsappModal.menuItem.disabled")}
                              </MenuItem>
                              {integrations
                                .filter(
                                  (integration) =>
                                    integration.type === "n8n" ||
                                    integration.type === "typebot"
                                )
                                .map((integration) => (
                                  <MenuItem key={integration.id} value={integration.id}>
                                    {integration.name}
                                  </MenuItem>
                                ))}
                            </Field>
                          </FormControl>
                        </div>
                      )}
                    </div>

                    {showWavoipCall && (
                      <div className={`${m.optionBox} ${a.switchBox}`}>
                        <CallIcon />
                        <div style={{ minWidth: 0 }}>
                          <div className={m.optionTitle}>Wavoip</div>
                          <div className={m.optionDesc}>
                            {i18n.t("aeros.connections.form.wavoipHint")}
                          </div>
                        </div>
                        <Field
                          as={TextField}
                          name="wavoip"
                          variant="outlined"
                          className={`${m.input} ${m.inputSmall}`}
                          style={{ width: 200, marginLeft: "auto" }}
                          placeholder={i18n.t("aeros.connections.form.wavoipPlaceholder")}
                        />
                      </div>
                    )}
                  </DialogContent>
                </TabPanel>
                <TabPanel
                  className={a.panel}
                  value={tab}
                  name={"messages"}
                >
                  <DialogContent>
                    {/* Cada mensagem com rótulo e dica do mockup */}
                    <div>
                      <label className={m.fieldLabel}>
                        {i18n.t("whatsappModal.form.greetingMessage")}
                      </label>
                      <Field
                        as={TextField}
                        multiline
                        minRows={3}
                        fullWidth
                        name="greetingMessage"
                        error={
                          touched.greetingMessage &&
                          Boolean(errors.greetingMessage)
                        }
                        helperText={
                          touched.greetingMessage && errors.greetingMessage
                        }
                        variant="outlined"
                        className={m.input}
                      />
                      <div className={m.hint}>
                        {i18n.t("aeros.connections.form.greetingHint")}
                      </div>
                    </div>

                    <div>
                      <label className={m.fieldLabel}>
                        {i18n.t("whatsappModal.form.complationMessage")}
                      </label>
                      <Field
                        as={TextField}
                        multiline
                        minRows={3}
                        fullWidth
                        name="complationMessage"
                        error={
                          touched.complationMessage &&
                          Boolean(errors.complationMessage)
                        }
                        helperText={
                          touched.complationMessage && errors.complationMessage
                        }
                        variant="outlined"
                        className={m.input}
                      />
                      <div className={m.hint}>
                        {i18n.t("aeros.connections.form.complationHint")}
                      </div>
                    </div>

                    <div>
                      <label className={m.fieldLabel}>
                        {i18n.t("whatsappModal.form.outOfHoursMessage")}
                      </label>
                      <Field
                        as={TextField}
                        multiline
                        minRows={3}
                        fullWidth
                        name="outOfHoursMessage"
                        error={
                          touched.outOfHoursMessage &&
                          Boolean(errors.outOfHoursMessage)
                        }
                        helperText={
                          touched.outOfHoursMessage && errors.outOfHoursMessage
                        }
                        variant="outlined"
                        className={m.input}
                      />
                      <div className={m.hint}>
                        {i18n.t("aeros.connections.form.outOfHoursHint")}
                      </div>
                    </div>

                    <div>
                      <label className={m.fieldLabel}>
                        {i18n.t("whatsappModal.form.collectiveVacationMessage")}
                      </label>
                      <Field
                        as={TextField}
                        multiline
                        minRows={3}
                        fullWidth
                        name="collectiveVacationMessage"
                        error={
                          touched.collectiveVacationMessage &&
                          Boolean(errors.collectiveVacationMessage)
                        }
                        helperText={
                          touched.collectiveVacationMessage &&
                          errors.collectiveVacationMessage
                        }
                        variant="outlined"
                        className={m.input}
                      />
                      <div className={m.hint}>
                        {i18n.t("aeros.connections.form.vacationHint")}
                      </div>
                    </div>

                    <div className={m.grid2}>
                      <div>
                        <label className={m.fieldLabel}>
                          {i18n.t("whatsappModal.form.collectiveVacationStart")}
                        </label>
                        <Field
                          fullWidth
                          as={TextField}
                          type="date"
                          name="collectiveVacationStart"
                          required={values.collectiveVacationMessage?.length > 0}
                          inputProps={{
                            min: moment().add(-10, "days").format("YYYY-MM-DD"),
                          }}
                          variant="outlined"
                          className={m.input}
                        />
                      </div>
                      <div>
                        <label className={m.fieldLabel}>
                          {i18n.t("whatsappModal.form.collectiveVacationEnd")}
                        </label>
                        <Field
                          fullWidth
                          as={TextField}
                          type="date"
                          name="collectiveVacationEnd"
                          required={values.collectiveVacationMessage?.length > 0}
                          inputProps={{
                            min: moment().add(-10, "days").format("YYYY-MM-DD"),
                          }}
                          variant="outlined"
                          className={m.input}
                        />
                      </div>
                    </div>
                  </DialogContent>
                </TabPanel>

                <TabPanel
                  className={a.panel}
                  value={tab}
                  name={"chatbot"}
                >
                  <DialogContent>
                    <div className={a.botGrid}>
                      <BotTimeCard
                        a={a}
                        icon={<AddCommentIcon />}
                        label={i18n.t("whatsappModal.form.timeCreateNewTicket")}
                        hint={i18n.t("aeros.connections.bot.newTicketHint")}
                        unit={i18n.t("aeros.connections.bot.unitMin")}
                      >
                        <Field
                          as={TextField}
                          fullWidth
                          name="timeCreateNewTicket"
                          variant="outlined"
                          className={`${m.input} ${m.inputSmall}`}
                          error={
                            touched.timeCreateNewTicket &&
                            Boolean(errors.timeCreateNewTicket)
                          }
                          helperText={
                            touched.timeCreateNewTicket &&
                            errors.timeCreateNewTicket
                          }
                        />
                      </BotTimeCard>

                      <BotTimeCard
                        a={a}
                        icon={<RepeatIcon />}
                        label={i18n.t("whatsappModal.form.maxUseBotQueues")}
                        hint={i18n.t("aeros.connections.bot.maxTriesHint")}
                        unit={i18n.t("aeros.connections.bot.unitTimes")}
                      >
                        <Field
                          as={TextField}
                          fullWidth
                          name="maxUseBotQueues"
                          variant="outlined"
                          className={`${m.input} ${m.inputSmall}`}
                          error={
                            touched.maxUseBotQueues &&
                            Boolean(errors.maxUseBotQueues)
                          }
                          helperText={
                            touched.maxUseBotQueues && errors.maxUseBotQueues
                          }
                        />
                      </BotTimeCard>

                      <BotTimeCard
                        a={a}
                        icon={<HourglassEmptyIcon />}
                        label={i18n.t("whatsappModal.form.timeUseBotQueues")}
                        hint={i18n.t("aeros.connections.bot.intervalHint")}
                        unit={i18n.t("aeros.connections.bot.unitMin")}
                      >
                        <Field
                          as={TextField}
                          fullWidth
                          name="timeUseBotQueues"
                          variant="outlined"
                          className={`${m.input} ${m.inputSmall}`}
                          error={
                            touched.timeUseBotQueues &&
                            Boolean(errors.timeUseBotQueues)
                          }
                          helperText={
                            touched.timeUseBotQueues && errors.timeUseBotQueues
                          }
                        />
                      </BotTimeCard>

                      <BotTimeCard
                        a={a}
                        icon={<UndoIcon />}
                        label={i18n.t("whatsappModal.form.timeToReturnQueue")}
                        hint={i18n.t("aeros.connections.bot.returnQueueHint")}
                        unit={i18n.t("aeros.connections.bot.unitMin")}
                      >
                        <Field
                          as={TextField}
                          fullWidth
                          name="timeToReturnQueue"
                          variant="outlined"
                          className={`${m.input} ${m.inputSmall}`}
                          error={
                            touched.timeToReturnQueue &&
                            Boolean(errors.timeToReturnQueue)
                          }
                          helperText={
                            touched.timeToReturnQueue && errors.timeToReturnQueue
                          }
                        />
                      </BotTimeCard>

                      <BotTimeCard
                        a={a}
                        icon={<TimerOffIcon />}
                        label={i18n.t("whatsappModal.form.expiresTicket")}
                        hint={i18n.t("aeros.connections.bot.expiresHint")}
                        unit={i18n.t("aeros.connections.bot.unitMin")}
                      >
                        <Field
                          as={TextField}
                          fullWidth
                          name="expiresTicket"
                          variant="outlined"
                          className={`${m.input} ${m.inputSmall}`}
                          error={
                            touched.expiresTicket && Boolean(errors.expiresTicket)
                          }
                          helperText={
                            touched.expiresTicket && errors.expiresTicket
                          }
                        />
                      </BotTimeCard>

                      <BotTimeCard
                        a={a}
                        icon={<RuleIcon />}
                        label={i18n.t("whatsappModal.form.whenExpiresTicket")}
                        hint={i18n.t("aeros.connections.bot.whenExpiresHint")}
                      >
                        <FormControl
                          variant="outlined"
                          fullWidth
                          className={`${m.input} ${m.inputSmall}`}
                        >
                          <Field
                            as={Select}
                            name="whenExpiresTicket"
                            id="whenExpiresTicket"
                          >
                            <MenuItem value={"0"}>
                              {i18n.t(
                                "whatsappModal.form.closeLastMessageOptions1"
                              )}
                            </MenuItem>
                            <MenuItem value={"1"}>
                              {i18n.t(
                                "whatsappModal.form.closeLastMessageOptions2"
                              )}
                            </MenuItem>
                          </Field>
                        </FormControl>
                      </BotTimeCard>
                    </div>

                    <div>
                      <label className={m.fieldLabel}>
                        {i18n.t("whatsappModal.form.expiresInactiveMessage")}
                      </label>
                      <Field
                        as={TextField}
                        multiline
                        minRows={3}
                        fullWidth
                        name="expiresInactiveMessage"
                        error={
                          touched.expiresInactiveMessage &&
                          Boolean(errors.expiresInactiveMessage)
                        }
                        helperText={
                          touched.expiresInactiveMessage &&
                          errors.expiresInactiveMessage
                        }
                        variant="outlined"
                        className={m.input}
                      />
                      <div className={m.hint}>
                        {i18n.t("aeros.connections.bot.expiresMessageHint")}
                      </div>
                    </div>

                    {/* Aviso de inatividade antes de expirar */}
                    <div className={m.section} style={{ padding: 14 }}>
                      <div className={a.sectionTitle}>
                        {i18n.t("aeros.connections.bot.inactivityTitle")}
                      </div>
                      <div className={a.sectionDesc}>
                        {i18n.t("aeros.connections.bot.inactivityDesc")}
                      </div>

                      <div className={m.grid2}>
                        <div>
                          <label className={m.fieldLabel}>
                            {i18n.t("whatsappModal.form.timeInactiveMessage")}
                          </label>
                          <Field
                            as={TextField}
                            fullWidth
                            name="timeInactiveMessage"
                            variant="outlined"
                            className={m.input}
                            error={
                              touched.timeInactiveMessage &&
                              Boolean(errors.timeInactiveMessage)
                            }
                            helperText={
                              touched.timeInactiveMessage &&
                              errors.timeInactiveMessage
                            }
                          />
                        </div>
                        <div>
                          <label className={m.fieldLabel}>
                            {i18n.t("whatsappModal.form.maxUseInactiveTime")}
                          </label>
                          <Field
                            as={TextField}
                            fullWidth
                            name="maxUseInactiveTime"
                            variant="outlined"
                            className={m.input}
                            error={
                              touched.maxUseInactiveTime &&
                              Boolean(errors.maxUseInactiveTime)
                            }
                            helperText={
                              touched.maxUseInactiveTime &&
                              errors.maxUseInactiveTime
                            }
                          />
                        </div>
                      </div>

                      <div style={{ marginTop: 10 }}>
                        <label className={m.fieldLabel}>
                          {i18n.t("whatsappModal.form.inactiveMessage")}
                        </label>
                        <Field
                          as={TextField}
                          multiline
                          minRows={3}
                          fullWidth
                          name="inactiveMessage"
                          error={
                            touched.inactiveMessage &&
                            Boolean(errors.inactiveMessage)
                          }
                          helperText={
                            touched.inactiveMessage && errors.inactiveMessage
                          }
                          variant="outlined"
                          className={m.input}
                        />
                      </div>

                      {user.showFlow === "enabled" && (
                        <div className={m.grid2} style={{ marginTop: 10 }}>
                          <div>
                            <label className={m.fieldLabel}>
                              {i18n.t("whatsappModal.form.flowInactiveTime")}
                            </label>
                            <Field
                              as={TextField}
                              fullWidth
                              name="flowInactiveTime"
                              variant="outlined"
                              className={m.input}
                              error={
                                touched.flowIdInactiveTime &&
                                Boolean(errors.flowIdInactiveTime)
                              }
                              helperText={
                                touched.flowIdInactiveTime &&
                                errors.flowIdInactiveTime
                              }
                            />
                          </div>
                          <div>
                            <label className={m.fieldLabel}>
                              {i18n.t("aeros.connections.bot.inactivityFlow")}
                            </label>
                            <FormControl
                              variant="outlined"
                              fullWidth
                              className={m.input}
                            >
                              <Select
                                name="flowIdInactiveTime"
                                value={flowIdInactiveTime || ""}
                                onChange={handleChangeFlowIdInactiveTime}
                                id="flowIdInactiveTime"
                              >
                                <MenuItem value={null}>
                                  {i18n.t("whatsappModal.menuItem.disabled")}
                                </MenuItem>
                                {webhooks.map((webhook) => (
                                  <MenuItem key={webhook.id} value={webhook.id}>
                                    {webhook.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </div>
                        </div>
                      )}
                    </div>
                  </DialogContent>
                </TabPanel>

                {/* NPS */}
                <TabPanel
                  className={a.panel}
                  value={tab}
                  name={"nps"}
                >
                  <DialogContent>
                    <div>
                      <label className={m.fieldLabel}>
                        {i18n.t("whatsappModal.form.ratingMessage")}
                      </label>
                      <Field
                        as={TextField}
                        multiline
                        minRows={3}
                        fullWidth
                        name="ratingMessage"
                        error={
                          touched.ratingMessage && Boolean(errors.ratingMessage)
                        }
                        helperText={touched.ratingMessage && errors.ratingMessage}
                        variant="outlined"
                        className={m.input}
                      />
                    </div>

                    <div className={m.grid2}>
                      <div>
                        <label className={m.fieldLabel}>
                          {i18n.t("whatsappModal.form.expiresTicketNPS")}
                        </label>
                        <div className={a.botCardField}>
                          <Field
                            as={TextField}
                            fullWidth
                            name="expiresTicketNPS"
                            variant="outlined"
                            className={m.input}
                            error={
                              touched.expiresTicketNPS &&
                              Boolean(errors.expiresTicketNPS)
                            }
                            helperText={
                              touched.expiresTicketNPS && errors.expiresTicketNPS
                            }
                          />
                          <span className={a.botCardUnit}>
                            {i18n.t("aeros.connections.bot.unitMin")}
                          </span>
                        </div>
                        <div className={m.hint}>
                          <InfoOutlinedIcon />
                          {i18n.t("aeros.connections.nps.expiresHint")}
                        </div>
                      </div>

                      <div>
                        <label className={m.fieldLabel}>
                          {i18n.t("whatsappModal.form.maxUseBotQueuesNPS")}
                        </label>
                        <div className={a.botCardField}>
                          <Field
                            as={TextField}
                            fullWidth
                            name="maxUseBotQueuesNPS"
                            variant="outlined"
                            className={m.input}
                            error={
                              touched.maxUseBotQueuesNPS &&
                              Boolean(errors.maxUseBotQueuesNPS)
                            }
                            helperText={
                              touched.maxUseBotQueuesNPS &&
                              errors.maxUseBotQueuesNPS
                            }
                          />
                          <span className={a.botCardUnit}>
                            {i18n.t("aeros.connections.bot.unitTimes")}
                          </span>
                        </div>
                        <div className={m.hint}>
                          {i18n.t("aeros.connections.nps.maxUseHint")}
                        </div>
                      </div>
                    </div>
                  </DialogContent>
                </TabPanel>

                {/* Flowbuilder */}
                {showIntegrations && user.showFlow === "enabled" && (
                  <>
                    <TabPanel
                      className={a.panel}
                      value={tab}
                      name={"flowbuilder"}
                    >
                      <DialogContent>
                        {/* Slots de fluxo do mockup: rótulo + seletor */}
                        <div className={m.section} style={{ padding: 14 }}>
                          <div className={a.sectionTitle}>
                            {i18n.t("aeros.connections.flow.newContactTitle")}
                          </div>
                          <div className={a.sectionDesc}>
                            {i18n.t("aeros.connections.flow.newContactDesc")}
                          </div>
                          <FormControl
                            variant="outlined"
                            fullWidth
                            className={m.input}
                          >
                            <Select
                              name="flowIdNotPhrase"
                              value={flowIdNotPhrase || ""}
                              onChange={handleChangeFlowIdNotPhrase}
                              id="flowIdNotPhrase"
                              startAdornment={
                                <InputAdornment position="start">
                                  <AccountTreeIcon
                                    style={{ fontSize: 16, opacity: 0.7 }}
                                  />
                                </InputAdornment>
                              }
                            >
                              <MenuItem value={null}>
                                {i18n.t("whatsappModal.menuItem.disabled")}
                              </MenuItem>
                              {webhooks.map((webhook) => (
                                <MenuItem key={webhook.id} value={webhook.id}>
                                  {webhook.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>

                        <div className={m.section} style={{ padding: 14 }}>
                          <div className={a.sectionTitle}>
                            {i18n.t("aeros.connections.flow.knownContactTitle")}
                          </div>
                          <div className={a.sectionDesc}>
                            {i18n.t("aeros.connections.flow.knownContactDesc")}
                          </div>
                          <FormControl
                            variant="outlined"
                            fullWidth
                            className={m.input}
                          >
                            <Select
                              name="flowIdWelcome"
                              value={flowIdWelcome || ""}
                              onChange={handleChangeFlowIdWelcome}
                              id="flowIdWelcome"
                              startAdornment={
                                <InputAdornment position="start">
                                  <AccountTreeIcon
                                    style={{ fontSize: 16, opacity: 0.7 }}
                                  />
                                </InputAdornment>
                              }
                            >
                              <MenuItem value={null}>
                                {i18n.t("whatsappModal.menuItem.disabled")}
                              </MenuItem>
                              {webhooks.map((webhook) => (
                                <MenuItem key={webhook.id} value={webhook.id}>
                                  {webhook.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      </DialogContent>
                    </TabPanel>
                  </>
                )}

                {/* Schedules */}
                <TabPanel
                  className={classes.container}
                  value={tab}
                  name={"schedules"}
                >
                  {tab === "schedules" && (
                    <Paper style={{ padding: 20 }}>
                      <SchedulesForm
                        loading={false}
                        onSubmit={handleSaveSchedules}
                        initialValues={schedules}
                        labelSaveButton={i18n.t("whatsappModal.buttons.okAdd")}
                      />
                    </Paper>
                  )}
                </TabPanel>
              </div>
              <div className={a.footer}>
                <div className={a.footerActions}>
                <Button
                  onClick={handleClose}
                  disabled={isSubmitting}
                  className={a.cancelButton}
                >
                  {i18n.t("whatsappModal.buttons.cancel")}
                </Button>
                <Button
                  type="submit"
                  color="primary"
                  disabled={isSubmitting}
                  variant="contained"
                  className={a.submitButton}
                >
                  {whatsAppId
                    ? i18n.t("whatsappModal.buttons.okEdit")
                    : i18n.t("whatsappModal.buttons.okAdd")}
                  {isSubmitting && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}
                </Button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Dialog>
    </div >
  );
};

export default React.memo(WhatsAppModal);
